import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    transferenciasPremiosImputaciones: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    transferenciasPremiosImputaciones: 0,
    sortByDescending: false,

    transferenciasPremiosImputacionesList: [],

    rptTotalesTransferenciasPremiosImputaciones: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.transferenciasPremiosImputaciones = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.transferenciasPremiosImputaciones = 0;
        state.sortByDescending = false;
    },

    'INICIALIZAR_IMPUTACIONES' (state) {
        state.transferenciasPremiosImputaciones = [];
    },
    'SET_IMPUTACIONES' (state, transferenciasPremiosImputaciones) {
        state.transferenciasPremiosImputaciones = transferenciasPremiosImputaciones;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_IMPUTACIONES_LIST' (state) {
        state.transferenciasPremiosImputacionesList = [];
    },
    'SET_IMPUTACIONES_LIST' (state, transferenciasPremiosImputacionesList) {
        state.transferenciasPremiosImputacionesList = transferenciasPremiosImputacionesList;
    },

    'INICIALIZAR_RPT_TOTALES' (state) {
        state.rptTotalesTransferenciasPremiosImputaciones = [];
    },
    'SET_RPT_TOTALES' (state, rptTotalesTransferenciasPremiosImputaciones) {
        state.rptTotalesTransferenciasPremiosImputaciones = rptTotalesTransferenciasPremiosImputaciones;
    },
};

const getters = {
    getField,

    transferenciasPremiosImputacionesList(state) {
        return state.transferenciasPremiosImputacionesList;
    },

    rptTotalesTransferenciasPremiosImputaciones(state) {
        return state.rptTotalesTransferenciasPremiosImputaciones;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getImputacionesTransferencias ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_IMPUTACIONES');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }

            if (state.numeroPresupuesto != 0) {
                queryString += '&numeroPresupuesto=' + state.numeroPresupuesto;
            }
  
            apiAxios.get('bancosmovimientos/transferencias-premios-imputaciones' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_IMPUTACIONES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getImputacionesTransferenciasList ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_IMPUTACIONES_LIST');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.numeroPresupuesto != 0) {
                queryString += '&numeroPresupuesto=' + state.numeroPresupuesto;
            }
  
            apiAxios.get('bancosmovimientos/transferencias-premios-imputaciones/list' + queryString)
                .then(res => {
                    commit('SET_IMPUTACIONES_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, transferenciaPremiosImputacionId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('bancosmovimientos/transferencias-premios-imputaciones' + '/' + transferenciaPremiosImputacionId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptTotalesImputacionesTransferencias ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_TOTALES');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            if (params.clienteId != 0) {
                queryString += '&clienteId=' + params.clienteId;
            }
  
            apiAxios.get('bancosmovimientos/transferencias-premios-imputaciones/totales' + queryString)
                .then(res => {
                    commit('SET_RPT_TOTALES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}